module.exports = __webpack_public_path__ + "assets/img/3.5bb82042.jpg";